const defaultDynamicRoutes = [
  {
    path: '/news',
    component: 'page-layout-news-list',
    name: 'Latest News',
    meta: {
      requiresAuth: 'allow'
    }
  },
  {
    path: '/news/:path',
    component: 'page-content-type-news',
    meta: {
      requiresAuth: 'cache',
      ContentItemCheck: true
    }
  }
]
export {
  defaultDynamicRoutes
}
